import VideoDataRelatedVideo from '@/data/VideoDataRelatedVideo';

export default class VideoData {
  private _url: string;
  private _relatedVideos: Array<VideoDataRelatedVideo> = [];
  
  constructor(url: string) {
    this._url = url;
  }
  get url() {
    return this._url;
  }
  public get relatedVideos(): Array<VideoDataRelatedVideo> {
    return this._relatedVideos;
  }
  public set relatedVideos(value: Array<VideoDataRelatedVideo>) {
    this._relatedVideos = value;
  }
}